import * as React from 'react';

import Loading from './Loading';

const PanelBody: React.FunctionComponent<{
  disabled?: boolean;
  loading?: boolean;
  fullHeight?: boolean;
  style?: React.CSSProperties;
}> = ({ children, disabled, loading, fullHeight = true, style = {} }) => (
  <div className="content animate-panel transition animated fadeIn">
    <div className="hpanel">
      <div
        className="panel-body"
        style={{
          display: 'flex',
          minHeight: fullHeight ? 'calc(100vh - 175px)' : 'auto',
          ...style,
        }}
      >
        {loading && (
          <div className="panel-loading">
            <Loading size={'fa-5x'} />
          </div>
        )}
        {disabled && <div className="panel-overlay"></div>}
        {children}
      </div>
    </div>
  </div>
);

export default PanelBody;
